import React from "react";
import rehypeRaw from "rehype-raw";
import ReactMarkdown from "react-markdown";
var HTMLRenderer = function (_a) {
    var htmlContent = _a.htmlContent, _b = _a.className, className = _b === void 0 ? "" : _b;
    return (React.createElement(ReactMarkdown, { className: className, rehypePlugins: [rehypeRaw], children: htmlContent }));
};
export default HTMLRenderer;
//# sourceMappingURL=HTMLRenderer.js.map